export default __webpack_public_path__ + "static/icon-dropdown-careers-5c90e321f7551266f967911866842f45.svg";